import { Button, Input, message, Row, Typography } from "antd";
import { ReactComponent as Logoo } from "./Svgs/Cohort.svg";
import React, { useState } from 'react'
import { updateLanguageEquivalentApi } from "utils/apiService";
import { getAllLabelsData } from "actions/MultiLanguageActions";
import { useDispatch } from "react-redux";
const { Text } = Typography;

export default function EditLanguageEquivalentModal(props) {
    const { closeModal, labelData } = props;
    const [label, setLabel] = useState({
        uuid: labelData.translation_uuid,
        value: labelData.translation_value,
    });
    const dispatch = useDispatch()

    const formValidation = (label) => {
        for (var key of Object.keys(label)) {
            if (label[key] == "" || !label[key]) {
                message.error(`${key} is required`);
                return false;
            }
        }
        return true;
    };

    const editLangEquivalent = async (label) => {
        if (!formValidation(label)) {
            return;
        }
        updateLanguageEquivalentApi({
            requestData: label,
            res200Callback: () => {
                message.success("Language Equivalent updated successfully.");
                getAllLabelsData(dispatch)
                closeModal()
            },
            resErrorCallback: () => {
                message.error("Failed updating the Language Equivalent!");
            },
        });
    };

    return (
        <div>
            <Row className="modal-row">
                <Row>
                    <div style={{ display: "flex" }}>
                        <div>
                            <Logoo style={{ marginTop: "2px" }} />
                        </div>
                        <Text
                            style={{
                                marginLeft: "16px",
                                fontWeight: "700",
                                color: "#181818",
                                fontSize: "24px",
                                fontStyle: "normal",
                                lineHeight: "40px",
                            }}>
                            Edit Language Equivalent
                        </Text>
                    </div>
                </Row>

                <div style={{ margin: "16px 0px", background: "#E8E8E8", height: "1px" }}></div>

                <Row className="stores_wrapper">
                    <div>
                        <div>
                            <div>
                                <Text
                                    style={{
                                        fontSize: "14px",
                                        color: "#181818",
                                        fontWeight: "bold",
                                        // fontWeight:"bold"
                                    }}>
                                    Language Equivalent
                                </Text>
                            </div>
                            <Input
                                className="time-value-cohort-col-main-element"
                                style={{ width: "100%", marginTop: "4px" }}
                                placeholder="Enter Label"
                                value={label.value}
                                onChange={(event) => {
                                    setLabel({
                                        ...label,
                                        ["value"]: event.target.value,
                                    });
                                }}
                                name="name"
                            />
                        </div>
                    </div>

                    <div
                        style={{
                            marginTop: "24px ",
                            background: "#E8E8E8",
                            height: "1px",
                        }}></div>
                    <Row
                        type="flex"
                        justify="end"
                        align="middle"
                        style={{
                            marginTop: "32px",
                        }}>
                        <Button
                            size="large"
                            style={{
                                height: "40px",
                                boxShadow: "none",
                                borderRadius: "20px",
                                border: "none",
                                backgroundColor: "#FFFFFF",
                                color: "#181818",
                                marginRight: "12px",
                            }}
                            onClick={() => {
                                closeModal()
                            }}
                        >
                            Cancel
                        </Button>
                        <Button
                            size="large"
                            style={{
                                height: "40px",
                                borderRadius: "5px",
                                border: "none",
                                backgroundColor: "#fec708",
                                color: "#FFFFFF",
                            }}
                            onClick={() => {
                                editLangEquivalent(label);
                            }}>
                            Save
                        </Button>
                    </Row>
                </Row>
            </Row>
        </div>
    )
}
